import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHealthData } from '../../models/auth/healthSignin/healthSignin.model';

interface IInitialState {
  isAuthenticated: boolean;
  authData?: IHealthData | null;
}

const initialState: IInitialState = {
  isAuthenticated: false,
  authData: null,
};

// Load the initial state from localStorage
// const authDataFromStorage = localStorage.getItem('authData');
// const initialState: IInitialState = {
//   isAuthenticated: !!authDataFromStorage, // Convert to boolean
//   authData: authDataFromStorage ? JSON.parse(authDataFromStorage) : null,
// };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthentication(state, action: PayloadAction<IInitialState>) {
      state.authData = action.payload.authData;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    setAuthData(state, action: PayloadAction<IHealthData>) {
      state.authData = action.payload;
    },
    reset: () => initialState,
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
